import {mapboxgl} from 'mini-tokyo-3d';

export const {
    Evented,
    MercatorCoordinate
} = mapboxgl;
